import { createFileRoute, redirect } from '@tanstack/react-router'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/quality/')({
  staticData: {
    permission: ['read', 'quality'],
  },
  beforeLoad: () => {
    throw redirect({ to: '/quality/lots' })
  },
})
withRoutePermissions(Route)
